module.exports = __webpack_public_path__ + "img/lever05.c7039dee.png";